import { render, staticRenderFns } from "./MessagesTable.vue?vue&type=template&id=1ed776af&scoped=true&"
import script from "./MessagesTable.vue?vue&type=script&lang=ts&"
export * from "./MessagesTable.vue?vue&type=script&lang=ts&"
import style0 from "./MessagesTable.vue?vue&type=style&index=0&id=1ed776af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed776af",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
